import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom, map, shareReplay } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TemplateService {
  private readonly http = inject(HttpClient);

  // Load directly from your local JSON file
private readonly templates$ = this.http
    .get<{ templates: any[] }>('assets/entry-prompts/index.json')  

  listSummaries() {
    return this.templates$.pipe(
        map(({ templates }) =>
            templates
                .map(t => ({
                    id: t.id,
                    label: t.name,
                    description: t.prompt_blocks?.style_identity?.content ?? '',
                    previewUrl: `assets/entry-prompts/${t.id}/preview.png`,
                }))
        )
    );
}

async loadPrompt(id: string): Promise<string> {
    const data = await firstValueFrom(
        this.http.get<{ templates: any[] }>('assets/entry-prompts/index.json')
    );
	console.log(data)
    const template = data.templates.find(t => t.id === id);
    if (!template) throw new Error(`Template ${id} not found`);
    return template.prompt_blocks?.style_identity?.content ?? '';
}
}